import * as React from 'react'

interface PageLayoutProps {
  setFormDirtyState: (dirty: boolean) => void
  isFormDirty: boolean
}

const { Provider, Consumer } = React.createContext<PageLayoutProps>({
  isFormDirty: false,
  setFormDirtyState: (dirty: boolean) => dirty,
})

export { Provider, Consumer }
